import React from "react";

export default function ErrorPage() {
  return <div>Page Not Found</div>;
}
